import { Compass } from "lucide-react";
import { Link } from "react-router-dom";

import { EmptyState } from "@/components/feedback";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="grid min-h-screen place-items-center bg-bg px-6">
      <EmptyState
        icon={<Compass className="size-5" aria-hidden="true" />}
        title="Página não encontrada"
        description="O endereço que você tentou acessar não existe (ou mudou de lugar) no painel do EVENTOS.AI."
        action={
          <Button asChild>
            <Link to="/visao-geral">Voltar para o painel</Link>
          </Button>
        }
      />
    </div>
  );
}
